
import Vue from 'vue';
import Component from 'vue-class-component';
import NodeFormMixin from '../forms/NodeFormMixin';

@Component({
  name: 'InfoBoxSummary',
})
export default class InfoBoxSummary extends NodeFormMixin {
  get alertType(): string {
    switch (+this.data.action.gravity) {
      case this.$enums.Gravity.Error:
        return 'error';
      case this.$enums.Gravity.Info:
        return 'success';
      case this.$enums.Gravity.Warn:
        return 'warning';
    }
    return 'info';
  }
}
